export const UPDATE_CUSTOMER_TOUCH_FIELD = 'UPDATE_CUSTOMER_TOUCH_FIELD';
export const UPDATE_CUSTOMER_VALIDATE_FIELD = 'UPDATE_CUSTOMER_VALIDATE_FIELD';
export const UPDATE_CUSTOMER_UPDATE_FIELD = 'UPDATE_CUSTOMER_UPDATE_FIELD';
export const UPDATE_CUSTOMER_SUCCESS = 'UPDATE_CUSTOMER_SUCCESS';
export const UPDATE_CUSTOMERP_CLEAR_SUCCESS = 'UPDATE_CUSTOMERP_CLEAR_SUCCESS';



// WEBPACK FOOTER //
// ./src/app/membership/UpdateCustomerInfo/constants.js